module.exports = __webpack_public_path__ + "img/Alipay.5f4f9290.svg";